import type { LANGUAGES } from '@uefadigital/panenka';
import { translateEntity as pkTranslateEntity } from '@uefadigital/panenka';
import i18n from 'i18next';

export const translateEntity = <T>(entity: T) => pkTranslateEntity(entity, i18n.language.toUpperCase() as LANGUAGES);
